/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export class RuntimeImageTaskDefinitionError extends Error {
  constructor(message: string) {
    super(message);
  }
}
